import { EvaluationFilterMeta } from '@src/main/modules/reports/ui/mapEvaluationFiltersToCriteria';
import { DataTableFilterMeta } from 'primereact/datatable';

const isInvalidDateRange = (dateRange: unknown): boolean => {
  if (!Array.isArray(dateRange)) {
    return false;
  }

  const [startDate, endDate] = dateRange;

  if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
    return false;
  }

  return startDate > endDate;
};

export const useEvaluationFilterHandler = (
  setFilters: (filters: EvaluationFilterMeta) => void,
  refetchEvaluations: () => void,
  setInvalidDateModalVisible: (visible: boolean) => void,
) => {
  const handleSetFilters = (newFilters: DataTableFilterMeta) => {
    const filtersTyped = newFilters as EvaluationFilterMeta;
    const flightDateFilter = filtersTyped.flightDate?.constraints?.[0]?.value ?? null;
    const receptionDateFilter = filtersTyped.receptionDate?.constraints?.[0]?.value ?? null;

    if (isInvalidDateRange(flightDateFilter) || isInvalidDateRange(receptionDateFilter)) {
      setInvalidDateModalVisible(true);
      return;
    }

    setFilters(filtersTyped);
    refetchEvaluations();
  };

  return { handleSetFilters };
};
